
$('#further_content').owlCarousel({
  loop:true,
  items:5,
  margin:10,
  nav:true,
  dots:false,
  // dotsEach: 1,
  // autoplay:true,
  // autoplayTimeout:3000,
  // autoplayHoverPause:true,
  responsive:{
    0:{
      items:1.5
    },
    768:{
      items:2.5
    },
    980:{
      items:5
    }
  }
});
$('#testimonial_content').owlCarousel({
  loop:true,
  items:4,
  margin:20,
  nav:true,
  dots:true,
  autoplay:true,
  autoplayTimeout:3000,
  autoplayHoverPause:true,
  responsive:{
    0:{
      items:1
    },
    600:{
      items:3
    },
    1024:{
      items:4
    }
  }
});

$(document).ready(function() {
  var bigimage = $("#single_product");
  var thumbs = $("#thumbs");
  //var totalslides = 10;
  var syncedSecondary = true;

  bigimage
    .owlCarousel({
    items: 1,
    slideSpeed: 2000,
    nav:false,
    autoplay: false,
    dots: false,
    loop: true,
    responsiveRefreshRate: 200,
    navText: [
      '<i class="fa-solid fa-chevron-left"></i>',
      '<i class="fa-solid fa-chevron-right"></i>'
    ]
  })
    .on("changed.owl.carousel", syncPosition);

  thumbs
    .on("initialized.owl.carousel", function() {
    thumbs
      .find(".owl-item")
      .eq(0)
      .addClass("current");
  })
    .owlCarousel({
    items: 4,
    dots: false,
    nav: false,
    
    smartSpeed: 2000,
    slideSpeed: 2000,
    slideBy: 4,
    responsiveRefreshRate: 100
  })
    .on("changed.owl.carousel", syncPosition2);

  function syncPosition(el) {
    //if loop is set to false, then you have to uncomment the next line
    //var current = el.item.index;

    //to disable loop, comment this block
    var count = el.item.count - 1;
    var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

    if (current < 0) {
      current = count;
    }
    if (current > count) {
      current = 0;
    }
    //to this
    thumbs
      .find(".owl-item")
      .removeClass("current")
      .eq(current)
      .addClass("current");
    var onscreen = thumbs.find(".owl-item.active").length - 1;
    var start = thumbs
    .find(".owl-item.active")
    .first()
    .index();
    var end = thumbs
    .find(".owl-item.active")
    .last()
    .index();

    if (current > end) {
      thumbs.data("owl.carousel").to(current, 100, true);
    }
    if (current < start) {
      thumbs.data("owl.carousel").to(current - onscreen, 100, true);
    }
  }

  function syncPosition2(el) {
    if (syncedSecondary) {
      var number = el.item.index;
      bigimage.data("owl.carousel").to(number, 100, true);
    }
  }

  thumbs.on("click", ".owl-item", function(e) {
    e.preventDefault();
    var number = $(this).index();
    bigimage.data("owl.carousel").to(number, 300, true);
  });
});

$(document).ready(function () {
  var products_on_page = $(".products-on-page"),
  next_url = products_on_page.data("next-url"),
  load_more_btn = $(".load-more__btn"),
  load_more_spinner = $(".load-more__spinner");
  next_url == "" && load_more_btn.hide(),
  $(document).on("click", ".load-more__btn", function (e) {
    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
      beforeSend: function () {
          load_more_btn.hide();
          load_more_spinner.show();
      },
    }).done(function (next_page) {
      var new_products = $(next_page).find(".products-on-page"),
      new_url = new_products.data("next-url");
      new_url && load_more_btn.show(), (next_url = new_url), products_on_page.append(new_products.html());
      var grid_item_count = $(".products-on-page .latest-content").length;
      $(".product_display_count.count_cstm").text('SHOWING 1-'+grid_item_count+' OF 10 RESULTS');
      load_more_spinner.hide();
    });
  });
});
// remove class
$(document).ready(function() {
    if ($(window).width() < 991)
    {
      jQuery("#collapseexample").removeClass('show', '');
       // jQuery(".nav-item.dropdown a").removeAttr('href', '');
       // jQuery(".nav-item.dropdown a").attr('href', 'javascript:void(0)');
        jQuery(".nav-item.dropdown a").click(function(){
        jQuery(this).toggleClass('toggled-dropdown');
        jQuery(this).parent(".nav-item.dropdown").find("ul").toggle();
      });
    }
});
$(document).on("click", ".closed-btn", function(){
   $(".parent-accord-btn").trigger("click");
});

$(document).ready(function() {
   $('header .searchmodal').click(function(){
     $('#MainContent').addClass('backtigger');
   });
  $('.closemodal').click(function(){
     $('#MainContent').removeClass('backtigger');
   });  
});
$(document).ready(function() {
   $('button.navbar-toggler').click(function(){
     $('#MainContent').toggleClass('backtigger');
   });   
});
$(document).ready(function() {
   $('li.nav-item.dropdown').click(function(){
     $(this).toggleClass('show');
     $(this).find('ul.dropdown-menu').toggleClass('show');
   });
});

$(document).on('click','.snize-close-button', function() {
  if($("#collapsibleNavbar").hasClass("show")) {
    $('.navbar-toggler').trigger('click');
  }
});

// trigger-js-start
$(".owl-prev-btn").click(function(){
  $(".further-reduced .owl-nav button.owl-prev").trigger("click");
});
$(".owl-next-btn").click(function(){
  $(".further-reduced .owl-nav button.owl-next").trigger("click");
});
// trigger-js-end
